import React, {FC, MouseEventHandler, ReactNode, useEffect, useRef} from "react";
import styled from "styled-components";

const StyledAlertBackground = styled.div`
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    min-width: 998px;
    min-height: 576px;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1000;
    
    @keyframes fadeIn {
        0%, 20%, 40%, 60%, 80%, 100% {
            transition-timing-function: ease-in-out;
        }
        
        0% {
            opacity: 0;
        }
        
        100% {
            opacity: 1;
        }
    }
    
    @keyframes fadeOut {
        0%, 20%, 40%, 60%, 80%, 100% {
            transition-timing-function: ease-in-out;
        }
        
        0% {
            opacity: 1;
        }
        
        100% {
            opacity: 0;
        }
    }
    
    animation-duration: 0.5s;
    animation-fill-mode: both;
    animation-name: fadeIn;
`;

const StyledAlertFrame = styled.div`
    background: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
    word-break: break-all;
    text-align: center;
    width: 500px;
    border-radius: 3px;
    
    @keyframes slideUp {
        0%, 20%, 40%, 60%, 80%, 100% {
            transition-timing-function: ease-in-out;
        }
        
        0% {
            transform: translate(-50%, -20%);
            opacity: 0;
        }
        
        100% {
            transform: translate(-50%, -50%);
            opacity: 1;
        }
    }
    
    @keyframes fadeOut {
        0%, 20%, 40%, 60%, 80%, 100% {
            transition-timing-function: ease-in-out;
        }
        
        0% {
            opacity: 1;
        }
        
        100% {
            opacity: 0;
        }
    }
    
    animation-duration: 0.5s;
    animation-fill-mode: both;
    animation-name: slideUp;
`;

const StyledAlertTextFrame = styled.pre`
    color: rgb(0, 0, 0);
    padding: 42px 36px 24px;
    margin: 0;
    white-space: pre-line;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.4em;
    font-family: NanumSquareB;
`;

const StyledAlertConfirm = styled.button`
    margin-bottom: 39px;
    outline: none;
    border: 0px;
    cursor: pointer;
    background: #2E303C;
    border-radius: 5px;
    color: rgb(255, 255, 255);
    font-size: 18px;
    font-weight: bold;
    font-family: NanumSquareB;
    height: 40px;
    display: inline-block;
    opacity: 1;
    
    :hover {
        opacity: 0.9;
    }
    
    width: 200px;
`;

interface ICustomAlert {
    className?: string;
    children?: ReactNode;
    onClickOk?: MouseEventHandler<HTMLButtonElement>;
}

const CustomAlert: FC<ICustomAlert> = ({
                                           className,
                                           children,
                                           onClickOk,
                                       }) => {

    const refAlertBackground = useRef<HTMLDivElement>(null);
    const refAlert = useRef<HTMLDivElement>(null);

    const handleConfirm = (e: any) => {
        handleOnClickAfterAnimation(onClickOk, e);
    };

    const handleOnClickAfterAnimation = (callback: any, e: any) => {
        if (refAlert.current && refAlertBackground.current) {
            refAlertBackground.current.style.animationName = "fadeOut";
            refAlert.current.style.animationName = "fadeOut";
            refAlert.current.onanimationend = () => {
                if(refAlertBackground.current){
                    refAlertBackground.current.style.display = "none";
                }
                if (callback) {
                    callback(e);
                }
            };
        }
    };

    return (
        <StyledAlertBackground ref={refAlertBackground}>
                <StyledAlertFrame ref={refAlert} className={className}>
                    <StyledAlertTextFrame>
                        {children}
                    </StyledAlertTextFrame>
                    <StyledAlertConfirm onClick={handleConfirm}>
                        확인
                    </StyledAlertConfirm>
                </StyledAlertFrame>
        </StyledAlertBackground>
    )
};

export default CustomAlert;